export { default as HotelInformationComponent } from './HotelInformationComponent';
export { HotelInformationComponentEditable } from './HotelInformationComponent';
